import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;

  &.slide {
    opacity: 0;
    transition-duration: 2s;
    &.active {
      opacity: 1;
      transition-duration: 2s;
      z-index: 3;
    }
  }

  @media (max-width: 768px) {
    padding-bottom: 20px;
  }
`;

export const DotsContainer = styled.div`
  position: absolute;
  bottom: 8px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  @media (max-width: 768px) {
    bottom: 28px;
  }
`;

interface DotsProps {
  active: boolean;
}

export const Dots = styled.div<DotsProps>`
  width: 8px;
  height: 8px;
  background-color: ${({ active, theme }) =>
    active ? theme.colors.green : "#ffffff"};
  border-radius: 50%;
  cursor: pointer;
  /* box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px; */
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
`;
